module.exports = __webpack_public_path__ + "img/scenery-min.6c78c391.png";